import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { CLIENT_TYPE } from 'src/constants/type';
import useInitModuleFeatures from 'src/hooks/useInitModuleFeatures';
import { checkIsPWOrg } from 'src/services/utils';

import useBatchDetails from '../hooks/batches/useBatchDetails';
import useMetaData from '../hooks/video-player/useMetaData';
import useOttPlaylist from '../hooks/video-player/useOttPlaylist';
import useOttVideoDetails from '../hooks/video-player/useOttVideoDetails';
import useOttVideoUserData from '../hooks/video-player/useOttVideoUserData';
import useScheduleDetails, { ScheduleDetails } from '../hooks/video-player/useScheduleDetails';
import { selectPlayerParams, updateIsPWOrg, useSelector } from '../redux';
import { isOTT } from '../utilities';

export const useInitMetaDataApi = () => {
  const playerParams = useSelector(selectPlayerParams);
  const dispatch = useDispatch();
  useBatchDetails({
    batchSlug: playerParams.batchSlug as string,
    enabled: !!playerParams.batchSlug,
  });
  const { init, initWithoutSchedule } = useInitModuleFeatures();
  const { src, type } = playerParams;
  const hasSrcAndType = Boolean(src && type);

  const { batchDetails } = useMetaData();

  useScheduleDetails({
    batchId: batchDetails?._id || '',
    subjectSlug: (playerParams.subjectSlug as string) || '',
    scheduleId: (playerParams.scheduleId as string) || '',
    enabled: !!(playerParams.cameFrom === CLIENT_TYPE.ADMIN ||
    playerParams.cameFrom === CLIENT_TYPE.TEACHER_PORTAL ||
    playerParams.cameFrom?.toLowerCase() === CLIENT_TYPE.STUDIO_X
      ? playerParams.scheduleId
      : playerParams.scheduleId && batchDetails?._id && playerParams.subjectSlug),
    onSuccess(rawScheduleDetails) {
      // Initialize module features for videos which run on schedule
      const scheduleDetails = new ScheduleDetails(rawScheduleDetails, playerParams.cameFrom);
      init({ scheduleDetails, batchDetails });
    },
  });

  useOttVideoDetails({
    childId: playerParams.childId as string,
    enabled: !!playerParams.childId && isOTT(),
  });

  useOttVideoUserData({
    childId: playerParams.childId as string,
    enabled: !!playerParams.childId && !playerParams.playlistId && isOTT(),
  });

  useOttPlaylist({
    playlistId: playerParams.playlistId as string,
    enabled: !!playerParams.playlistId && isOTT(),
  });

  useEffect(() => {
    dispatch(updateIsPWOrg({ isPWOrg: checkIsPWOrg() }));
  }, [dispatch]);

  useEffect(() => {
    if (hasSrcAndType) {
      initWithoutSchedule();
    }
  }, [hasSrcAndType]);
};
